// extracted by mini-css-extract-plugin
export default {"wrapper":"SideMenuComponent_wrapper__PUGz5","hidden":"SideMenuComponent_hidden__esBC2","header":"SideMenuComponent_header__g0+X4"};